<template>
  <div
    :class="{'mobile-banner': isMobile}"
    class="banner-item-container">
    <div class="image-container" :class="!data[fieldName] ? 'img-empty': ''">
      <img
        class="mobile-image"
        v-if="imageSource && isMobile"
        :src="imageSource" />
      <div class="image-wrapper">
        <img
          v-if="imageSource && !isMobile"
          :src="imageSource" />
        <div class="empty-container" v-if="!imageSource">
          <div class="detail">{{noImageText}}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';

export default {
  props: {
    data: {
      type: Object,
      required: true,
    },
    fieldName: {
      type: String,
      default: 'coverImage',
    },
    thumborSize: {
      type: String,
      default: 'cover1280w720h',
    },
    isMobile: {
      type: Boolean,
      default: false,
      required: false,
    },
  },
  computed: {
    imageSource() {
      if (this.data[this.fieldName]) {
        if (typeof this.data[this.fieldName] === 'string') {
          return this.data[this.fieldName];
        }

        if (typeof this.data[this.fieldName] === 'object') {
          if (this.data[this.fieldName].type === 'thumbor') {
            if (this.thumborSize === 'original') {
              return this.generateOriginalSource(this.data[this.fieldName].baseUrl);
            }
            return _.get(this.data[this.fieldName].urls, this.thumborSize, null);
          }
          if (this.data[this.fieldName].type === 'thaipbsProgram') {
            return _.get(this.data[this.fieldName].urls, this.thumborSize, null);
          }
          if (_.isEmpty(this.data[this.fieldName])) {
            return this.defaultSource;
          }
          return _.get(this.data[this.fieldName].urls, this.thumborSize, null);
        }
      }

      if (this.defaultSource) {
        return this.defaultSource;
      }
      return null;
    },
    noImageText() {
      if (this.isMobile) {
        return 'ไม่ได้เลือกภาพสำหรับมือถือ';
      }
      return 'ไม่มีภาพแบนเนอร์';
    },
  },
  methods: {
    generateOriginalSource(mediaBaseUrl) {
      const idx = mediaBaseUrl.indexOf('/images');
      return `//${mediaBaseUrl.slice(0, idx + 7)}/original${mediaBaseUrl.slice(idx + 7, mediaBaseUrl.length)}`;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/scss/variables.scss';

.banner-item-container {
  display: flex;
  flex: 1;

  .image-container {
    width: 100%;
    padding-top: 25.77%;
    position: relative;
    overflow: hidden;

    .image-wrapper {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;

      img {
        width: 100%;
        position: absolute;
        top: 0;
        bottom: 0;
        margin: 0;
      }
    }
  }

  .img-empty {
    background-color: $gray-700;
    position: relative;

    .empty-container {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 100%;
      color: $gray-400;
      text-align: center;
      font-size: $font-size-sm;
      font-family: $font-family-base;
    }
  }

  &.mobile-banner {
    .image-container {
      width: 270px;
      padding-top: 0;
      .mobile-image {
        width: 100%;
      }
    }
  }
}

</style>
